module.exports = __webpack_public_path__ + "media/images/news/news1-ad348b726fb278d85f2b0395154ce5db.jpg";